if (!customElements.get('fr-autoplay-video')) {
  customElements.define('fr-autoplay-video', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      const video = this.querySelector('video');
      if (!video) return;
      // Keep pause/play available, including reduced-motion and blocked autoplay.
      video.controls = true;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        if (this.motionPreference.matches) video.pause();
      };
      this.motionPreference.addEventListener('change', this.onMotionChange);
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!this.isConnected) return;
          if (entry.isIntersecting && !this.motionPreference.matches) video.play()?.catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.01 });
      this.observer.observe(video);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.motionPreference?.removeEventListener('change', this.onMotionChange);
      this.querySelector('video')?.pause();
    }
  });
}

// Delegated controls work for every instance, including editor-inserted sections.
(() => {
  const enhanceAccordions = (root) => root.querySelectorAll('[data-accordion-header]').forEach((header) => {
    const item = header.closest('[data-accordion-item]');
    if (!(header instanceof HTMLButtonElement)) {
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
    }
    header.setAttribute('aria-expanded', String(item?.classList.contains('active')));
    header.querySelector('.accordion__header__icon')?.setAttribute('aria-hidden', 'true');
  });

  const enhanceKeyFeatures = (root) => root.querySelectorAll('[data-product-accordions] .accordion--key-feature').forEach((accordion) => {
    if (accordion.dataset.keyFeaturesEnhanced === 'true') return;
    const items = [...accordion.querySelectorAll('[data-key-feature-item]')];
    const toggle = accordion.querySelector('[data-key-feature-toggle]');
    if (!toggle || items.length <= 3) return;
    items.forEach((item, index) => { item.hidden = index >= 3; });
    toggle.hidden = false;
    accordion.dataset.keyFeaturesEnhanced = 'true';
  });

  const enhance = (root) => {
    enhanceAccordions(root);
    enhanceKeyFeatures(root);
  };

  enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.addEventListener('product-info:loaded', (event) => enhance(event.target.closest('main') || event.target));
  document.addEventListener('keydown', (event) => {
    const header = event.target.closest('[data-accordion-header]');
    if (!header || header instanceof HTMLButtonElement || event.target !== header || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    header.click();
  });
  document.addEventListener('click', (event) => {
    const header = event.target.closest('[data-accordion-header]');
    if (header) {
      const item = header.closest('[data-accordion-item]');
      if (!item) return;
      const expanded = item.classList.toggle('active');
      header.setAttribute('aria-expanded', String(expanded));
      const wrapper = header.closest('[data-accordion-wrapper="open-once"]');
      wrapper?.querySelectorAll('[data-accordion-header]').forEach((other) => {
        if (other === header) return;
        other.closest('[data-accordion-item]')?.classList.remove('active');
        other.setAttribute('aria-expanded', 'false');
      });
    }
    const featureToggle = event.target.closest('[data-product-accordions] [data-key-feature-toggle]');
    if (featureToggle) {
      const accordion = featureToggle.closest('.accordion--key-feature');
      const expanded = featureToggle.getAttribute('aria-expanded') !== 'true';
      accordion?.querySelectorAll('[data-key-feature-item]').forEach((item, index) => {
        item.hidden = !expanded && index >= 3;
      });
      featureToggle.setAttribute('aria-expanded', String(expanded));
      featureToggle.textContent = expanded ? 'Show fewer features' : 'Show all features';
    }
    const drawerTrigger = event.target.closest('[data-drawer-id], [data-close-drawer]');
    if (drawerTrigger && !drawerTrigger.disabled) {
      const closing = drawerTrigger.hasAttribute('data-close-drawer');
      const id = drawerTrigger.getAttribute(closing ? 'data-close-drawer' : 'data-drawer-id');
      const drawer = document.getElementById(id);
      if (drawer) {
        drawer.classList.toggle('active', !closing);
        document.documentElement.classList.toggle('opening-drawer', !closing);
      }
    }
    const closeAnnouncement = event.target.closest('.utility-bar__close');
    closeAnnouncement?.closest('.utility-bar')?.classList.add('hidden');
    const closeDrawer = event.target.closest('#close-drawer');
    if (closeDrawer) {
      const parent = closeDrawer.closest('header');
      parent?.querySelectorAll('header-menu').forEach((menu) => menu.close());
      parent?.querySelector('header-menu summary')?.focus();
    }
  });
})();
